import React, { useEffect, useState } from "react";
import { Portal } from "react-portal";
import { useStores } from "_common/hooks";
import i18next from "i18next";

import img01 from "assets/img/msb/1.jpeg";
import img02 from "assets/img/msb/2.jpeg";

function ModalMBS({ open, onClose }) {
  const {
    authStore: { general },
  } = useStores();

  return (
    <Portal>
      <div
        className="modal modal-desktop"
        style={{ display: open ? "block" : "none" }}
      >
        <div className="mask" onClick={() => onClose()} />
        <div className="modal-content ">
          <div className="modal-header">
            <h2>{i18next.t("Msb")}</h2>
            <div className="btn-close" onClick={() => onClose()}>
              X
            </div>
          </div>
          <div className="classic-bet-now">
            <div className="content">
              <div className="flex justify-between">
                <img src={img01} alt="" className="w-[45%]" />
                <img src={img02} alt="" className="w-[45%]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
}

export default ModalMBS;
